import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faUser , faFile } from "@fortawesome/free-solid-svg-icons";
import DealerShipDetails from "../services/DealerShipInfo";
import LogOut from "../services/LogOut";
import { useLanguage } from "./../common/LanguageContext";
import logo from "../assets/marutissymbol.png";

const UserProfile = () => {
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showLogoutDropdown, setShowLogoutDropdown] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const containerRef = useRef(null);

  const handleLogout = async () => {
    try {
      await LogOut.logOutDetails();
      // CRITICAL FIX: Clear ALL sessionStorage on MASS user logout
      // This removes all sensitive dealer data (GST, PAN, Phone, dealer codes) from sessionStorage
      // After logout, user is redirected to login page, so no functionality is affected
      sessionStorage.clear();
      console.log("[UserProfile] MASS user logout - cleared all sessionStorage");
      navigate("/login");
    } catch (error) {
      console.error("Error logging out:", error);
      // Even if logout API fails, clear sessionStorage and redirect to login
      sessionStorage.clear();
      navigate("/login");
    }
  };

  const [dealerShipInfo, setDealerShipInfo] = useState([]);
  const [empInfo, setEmpInfo] = useState(null);
  useEffect(() => {
    const fetchDealerShipInfo = async () => {
      try {
        const responseData = await DealerShipDetails.dealerShipDetails(`${language}`);
        setEmpInfo(responseData);
      } catch (error) {
        console.error("Error fetching service plans:", error);
      }
    };

    fetchDealerShipInfo();
  }, [language]);

  return (
    <div
      className="profile-logout-container"
      style={{ position: "relative", display: "inline-block" }}
      ref={containerRef}
    >
      <div className="d-flex align-items-center user-profile">
        <div
          className="rounded-circle me-2 d-flex align-items-center justify-content-center"
          style={{
            height: "40px",
            width: "40px",
            backgroundColor: "white",
            border: "1px solid #ddd",
            overflow: "hidden",
            position: "relative"
          }}
        >
          <img
            alt="Maruti Suzuki Logo"
            src={logo}
            style={{
              height: "26px",
              width: "26px",
              objectFit: "contain",
              display: "block",
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)"
            }}
          />
        </div>
        <span className="text-muted d-none d-md-block">
          {t("welcome")}, {empInfo} <span className="fw-bold"></span>
        </span>

        {/* Logout Icon with Left-Side Dropdown */}
        <div
          className="ms-2 position-relative"
          onMouseEnter={() => setShowLogoutDropdown(true)}
          onMouseLeave={() => setShowLogoutDropdown(false)}
        >
          <FontAwesomeIcon
            icon={faSignOutAlt}
            size="lg"
            style={{ cursor: "pointer", color: "#000", transition: "color 0.3s ease-in-out" }}
          />
          {showLogoutDropdown && (
            <div
              className="dropdown-menu show position-absolute"
              style={{
                top: "100%",
                left: "20px", // ✅ Moves dropdown left instead of right
                transform: "translateX(-80%)", // ✅ Fully shifts it left
                zIndex: 1000,
                boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                borderRadius: "5px",
                padding: "5px",
                backgroundColor: "white",
                width: "120px",
                overflow: "auto",
                maxHeight: "200px",
                color:"#333"
              }}
            >
              <button className="dropdown-item" onClick={handleLogout}>
                Logout
              </button>
            </div>
          )}
        </div>

        {/* Profile Icon with Left-Side Dropdown */}
        <div
          className="ms-2 position-relative"
          onMouseEnter={() => setShowProfileDropdown(true)}
          onMouseLeave={() => setShowProfileDropdown(false)}
          style={{ width: "24px", height: "24px", cursor: "pointer" }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="black">
            {[...Array(3)].map((_, row) =>
              [...Array(3)].map((_, col) => (
                <circle key={`${row}-${col}`} cx={6 + col * 6} cy={6 + row * 6} r="2" fill="black" />
              ))
            )}
          </svg>
          {showProfileDropdown && (
            <div
              className="dropdown-menu show position-absolute"
              style={{
                top: "100%",
                left: "10", // ✅ Moves dropdown left instead of right
                transform: "translateX(-90%)", // ✅ Fully shifts it left
                zIndex: 1000,
                boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                borderRadius: "5px",
                padding: "5px",
                backgroundColor: "white",
                width: "150px",
                overflow: "auto",
                maxHeight: "200px",
                whiteSpace: "nowrap",
              }}
            >
              <button className="dropdown-item" onClick={() => navigate("/reports")}>
              <FontAwesomeIcon icon={faFile} className="mr-2" /> &nbsp;
                Reports
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
